import React from 'react';
import SectionHeader from '../components/ui/SectionHeader';
import Badge from '../components/ui/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiTrendingUp, FiActivity, FiTv } from 'react-icons/fi';

export default function PortfolioMap() {
  const products = [
    {
      name: "The Pitch Feed",
      icon: FiTrendingUp,
      role: "Core Platform / Tip of Spear",
      desc: "Automated, high-quality sports news and content feed.",
      motion: "Lead with this for publishers lacking content volume.",
      status: "confirmed"
    },
    {
      name: "ScoreWidget",
      icon: FiActivity,
      role: "Engagement Add-on / Alternative Entry",
      desc: "Embeddable live scores, standings, and match data.",
      motion: "Lead with this if they have content but poor time-on-page. Upsell to Feed buyers.",
      status: "confirmed"
    },
    {
      name: "Fodbold TV Guide",
      icon: FiTv,
      role: "Niche Utility / Retention Tool",
      desc: "Localized TV and streaming schedules for football matches.",
      motion: "Upsell for capturing high-intent search traffic ('where to watch').",
      status: "verify"
    }
  ];

  return (
    <section>
      <SectionHeader id="portfolio" title="2. Product Portfolio Map" subtitle="How our products fit together." />
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {products.map((p, i) => (
          <div key={i} className="bg-slate-800 rounded-xl border border-slate-700 p-6 flex flex-col h-full hover:border-blue-500/50 transition-colors">
            <div className="flex items-center space-x-3 mb-4">
              <div className="p-3 bg-slate-900 rounded-lg text-blue-400">
                <SafeIcon icon={p.icon} size={24} />
              </div>
              <h3 className="text-xl font-bold text-white">{p.name}</h3>
            </div>
            
            <div className="mb-4">
              <Badge type={p.status}>{p.status === 'confirmed' ? 'Confirmed Core' : 'Needs Validation'}</Badge>
            </div>
            
            <p className="text-slate-300 text-sm mb-6 flex-grow">{p.desc}</p>
            
            <div className="space-y-3 text-sm border-t border-slate-700 pt-4">
              <div>
                <span className="text-slate-500 block text-xs uppercase">Role in Portfolio</span>
                <span className="text-white font-medium">{p.role}</span>
              </div>
              <div>
                <span className="text-slate-500 block text-xs uppercase">Sales Motion</span>
                <span className="text-blue-300">{p.motion}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-8 bg-blue-900/20 border border-blue-500/30 p-6 rounded-xl">
        <h4 className="text-white font-bold mb-2">The Bundle Strategy <Badge type="recommended">Recommended Play</Badge></h4>
        <p className="text-slate-300 text-sm">
          Never position these as unrelated tools. They are the <strong>"Attract & Retain"</strong> bundle. 
          The Feed <em>attracts</em> users via SEO and sheer volume. ScoreWidget <em>retains</em> them on the page. The TV Guide brings them back repeatedly. Pitch the ecosystem, not just the widget.
        </p>
      </div>
    </section>
  );
}